// src/components/Enrollments/constants/enrollmentsUi.js
// ============================================================================
// BLOCK ENR.UI.0 — UI constants for the Enrollments page
// ----------------------------------------------------------------------------
// PURPOSE
//  - Centralize all easy-to-tune UI values at the top of the feature.
//  - Keep page labels and column definitions consistent across components.
// ============================================================================

export const PAGE_PERMISSION_KEY = 'enrollments';
export const PAGE_TITLE = 'Enrollments';
export const PAGE_SUBTITLE = 'Studies Started by Type and Account';

export const DEFAULT_PAGE_LENGTH = 50;
export const ROWS_PER_PAGE_OPTIONS = [50, 250, 1000];

// Keep this aligned with the old ASPX validator unless business rules change.
export const MIN_YEAR = 2015;
export const MAX_YEAR = 2050;
export const DEFAULT_YEAR = new Date().getFullYear();

export const IGNORE_REPS = ['SPLIT COMMISSIONS', 'Trevor Vorhies', 'Jessica Viverito'];

export const COLUMN_DEFINITIONS = [
  { key: 'division', label: 'DIV', minWidth: 90, align: 'left' },
  { key: 'rep', label: 'REP', minWidth: 130, align: 'left' },
  { key: 'second_rep', label: '2ndRep', minWidth: 130, align: 'left' },
  { key: 'third_rep', label: '3rdRep', minWidth: 130, align: 'left' },
  { key: 'code', label: 'CODE', minWidth: 100, align: 'left' },
  { key: 'facility', label: 'Facility', minWidth: 220, align: 'left' },
  { key: 'patient_type', label: 'Service', minWidth: 170, align: 'left' },
  { key: 'state', label: 'State', minWidth: 90, align: 'left' },
  { key: 'year', label: 'Year', minWidth: 80, align: 'center' },
  { key: 'm1', label: 'Jan', minWidth: 70, align: 'right' },
  { key: 'm2', label: 'Feb', minWidth: 70, align: 'right' },
  { key: 'm3', label: 'Mar', minWidth: 70, align: 'right' },
  { key: 'm4', label: 'Apr', minWidth: 70, align: 'right' },
  { key: 'm5', label: 'May', minWidth: 70, align: 'right' },
  { key: 'm6', label: 'Jun', minWidth: 70, align: 'right' },
  { key: 'm7', label: 'Jul', minWidth: 70, align: 'right' },
  { key: 'm8', label: 'Aug', minWidth: 70, align: 'right' },
  { key: 'm9', label: 'Sep', minWidth: 70, align: 'right' },
  { key: 'm10', label: 'Oct', minWidth: 70, align: 'right' },
  { key: 'm11', label: 'Nov', minWidth: 70, align: 'right' },
  { key: 'm12', label: 'Dec', minWidth: 70, align: 'right' },
  { key: 'total', label: 'Total', minWidth: 80, align: 'right' },
];
